module.exports = __webpack_public_path__ + "img/knight.d7f0f669.png";